export default __webpack_public_path__ + "static/media/solutions-tablet.df41e149.jpg";